import * as React from 'react';
import { OmakaseTypographyVariant } from 'theme/typography/omakaseTypography';
import { Theme, css } from '@emotion/react';
import { Typography } from 'omakase';
import ConsumerDisplayMoney from 'components/ConsumerDisplayMoney';
import DisplayPercentage from '@tock/shared/components/number/DisplayPercentage';
import clsx from 'clsx';

const receiptLineItem = ({ colors }: Theme, isRefunded: boolean) => css`
  color: ${isRefunded ? colors.fgSuccessBase : colors.fgDefault};
`;

const receiptLineItemDetails = () => css`
  align-items: center;
  display: flex;
`;

interface Props {
  amount: number;
  bold?: boolean;
  refund?: boolean;
  className?: string;
  lineItem: React.ReactNode;
  percentage?: number;
  maximumFractionDigits?: number;
  subText?: string;
  toolTip?: React.ReactNode;
  'data-testid'?: string;
}

const ReceiptLine: React.FunctionComponent<Props> = ({
  amount,
  bold,
  className,
  lineItem,
  percentage,
  maximumFractionDigits,
  subText,
  toolTip,
  refund,
  ...rest
}) => {
  const classNames = clsx('Receipt-lineItem--first', className);
  const typographyVariant: OmakaseTypographyVariant = bold ? 'body02Strong' : 'body02';
  return (
    <div
      className={clsx('Receipt-lineItem', { 'is-negative': amount < 0 })}
      data-testid={rest['data-testid']}
      css={(theme: Theme) => receiptLineItem(theme, !!refund)}
    >
      <div
        css={css`
          max-width: 75%;
        `}
      >
        <Typography
          className={classNames}
          color="inherit"
          component="p"
          css={receiptLineItemDetails}
          variant={typographyVariant}
          data-testid={rest['data-testid'] + '-item'}
        >
          {lineItem}
          {percentage && (
            <DisplayPercentage value={percentage} maximumFractionDigits={maximumFractionDigits} />
          )}
          {toolTip}
        </Typography>
      </div>
      <p>
        <Typography color="inherit" component="span" variant={typographyVariant}>
          <ConsumerDisplayMoney amount={amount} data-testid={rest['data-testid'] + '-amount'} />
        </Typography>
      </p>
      {subText ? (
        <Typography
          css={css`
            flex-basis: 100%;
            width: 100%;
          `}
          component="p"
          variant="body02"
          color="fgSubtle"
        >
          {subText}
        </Typography>
      ) : null}
    </div>
  );
};

export default ReceiptLine;
